'use client';

import { useEffect, useState } from 'react';

import Link from 'next/link';

import Facebook from '@/components/icons/Facebook';
import GitHub from '@/components/icons/GitHub';
import LinkedIn from '@/components/icons/LinkedIn';
import Logo from '@/components/icons/Logo';
import Reddit from '@/components/icons/Reddit';
import Twitter from '@/components/icons/Twitter';

import { motion } from 'framer-motion';

export default function FooterBlog() {
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className='border-border bg-background text-foreground mt-auto border-t py-12'>
      <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
        <div className='grid grid-cols-1 gap-8 md:grid-cols-3'>
          {/* Brand Section */}
          <div className='flex flex-col items-center md:items-start'>
            <Link
              href='/'
              className='flex items-center space-x-3'>
              <Logo className='text-brand-dark dark:text-brand-dark-text-primary size-8' />
              <h3
                className='text-brand-dark dark:text-brand-dark-text-primary text-2xl font-bold tracking-tight font-serif'
                style={{ fontFamily: "'Lora', serif" }}>
                Bioinfometrics
              </h3>
            </Link>
            <p className='text-muted-foreground mt-4 text-center text-sm leading-relaxed md:text-left'>
              Bioinfometrics is the pulse of the bioeconomy revolution.
              Discovering data stories that shape the future of biotechnology
              and sustainability.
            </p>
          </div>

          {/* Navigation Section */}
          <div className='flex flex-col items-center md:items-start'>
            <h3 className='text-brand-dark dark:text-brand-dark-text-primary text-sm font-semibold tracking-wider uppercase'>
              Company
            </h3>
            <ul className='mt-4 space-y-2'>
              <li>
                <Link
                  href='/privacy'
                  className='hover:text-brand-accent text-sm transition-colors'>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href='/terms'
                  className='hover:text-brand-accent text-sm transition-colors'>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  href='/collection'
                  className='hover:text-brand-accent text-sm transition-colors'>
                  Collection Notice
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Section */}
          <div className='flex flex-col items-center md:items-start'>
            <h3 className='text-brand-dark dark:text-brand-dark-text-primary text-sm font-semibold tracking-wider uppercase'>
              Follow Us
            </h3>
            <div className='mt-4 flex space-x-4'>
              <a
                aria-label='Github Repository'
                href='https://github.com/iMartinDav'
                target='_blank'
                rel='noopener noreferrer'
                className='text-foreground hover:text-brand-dark dark:hover:text-brand-dark-text-primary transition-all hover:scale-110'>
                <GitHub className='size-6' />
              </a>
              <a
                aria-label='Twitter Profile'
                href='https://x.com/bioinfometrics'
                target='_blank'
                rel='noopener noreferrer'
                className='text-foreground hover:text-brand-dark dark:hover:text-brand-dark-text-primary transition-all hover:scale-110'>
                <Twitter className='size-6' />
              </a>
              <a
                aria-label='LinkedIn Profile'
                href='https://www.linkedin.com/company/bioinfometrics/about'
                target='_blank'
                rel='noopener noreferrer'
                className='text-foreground hover:text-brand-dark dark:hover:text-brand-dark-text-primary transition-all hover:scale-110'>
                <LinkedIn className='size-6' />
              </a>
              <a
                aria-label='Facebook Page'
                href='https://www.facebook.com/profile.php?id=61560884607940'
                target='_blank'
                rel='noopener noreferrer'
                className='text-foreground hover:text-brand-dark dark:hover:text-brand-dark-text-primary transition-all hover:scale-110'>
                <Facebook className='size-6' />
              </a>
              <a
                aria-label='Reddit Community'
                href='https://www.reddit.com/user/Bioinfometric/'
                target='_blank'
                rel='noopener noreferrer'
                className='text-foreground hover:text-brand-dark dark:hover:text-brand-dark-text-primary transition-all hover:scale-110'>
                <Reddit className='size-6' />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className='border-border mt-12 border-t pt-8 text-center'>
          <p className='text-muted-foreground text-xs'>
            © {year} Bioinfometrics, Inc. All rights reserved. Made with passion
            for the bioeconomy.
          </p>
        </div>
      </div>
    </motion.footer>
  );
}
